import {Backdrop, Button, Menu, MenuItem} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import {SpeedDial, SpeedDialAction, SpeedDialIcon} from '@material-ui/lab';
import {ModalState, showModal} from 'Core/ducks/modal';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import {Scope} from 'Shared/constants/Scope';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';
import { searchCustomerUsers } from 'Users/ducks/CustomerSupport';
import {Application} from 'Users/models/Application';
import {UserRouteConstants} from 'Users/Routes';
import './AddCustomerSupportMenu.sass';

type AddCustomerSupportMenuProps = {
  scopes: Scope[];
  showModal: typeof showModal;
  searchCustomerUsers: typeof searchCustomerUsers;
} & RouteComponentProps;

export const AddCustomerSupportMenu = (props: AddCustomerSupportMenuProps) => (
  <>
    {hasAccessToScopeByApplication(props.scopes, Scope.AddPreregistrationUsers, Application.Agent) && (
      <MenuStateProvider>
        {({open, close, anchor}) => (
          <div className="add-customer-support-menu">
            <Button
              variant="contained"
              color="primary"
              onClick={event => open(event.currentTarget)}
              className="add-customer-support-menu__button"
            >
              Add Agents
              <ArrowDown />
            </Button>
            <Menu
              open={Boolean(anchor)}
              onClose={close}
              title="Add Agents..."
              disablePortal
              anchorOrigin={{
                horizontal: 'center',
                vertical: 'bottom',
              }}
              transformOrigin={{
                horizontal: 'center',
                vertical: 'top',
              }}
              getContentAnchorEl={null}
              anchorEl={anchor}
            >
              <MenuItem
                onClick={() => {
                  close();
                  props.history.push(UserRouteConstants.INDEPENDENT_AGENT_PREREGISTRATION);
                }}
              >
                Agent
              </MenuItem>
              <MenuItem
                onClick={() => {
                  close();
                  props.history.push(UserRouteConstants.INDEPENDENT_AGENT_SUPPORT);
                }}
              >
                Agent Support
              </MenuItem>
            </Menu>
          </div>
        )}
      </MenuStateProvider>
    )}
  </>
);

export const AddCustomerSupportMobileMenu = withRouter((props: AddCustomerSupportMenuProps) => (
  <MenuStateProvider>
    {({open, close, anchor}) => (
      <>
        <Backdrop open={Boolean(anchor)} className="add-customer-support-menu__mobile-actions-backdrop" />
        <SpeedDial
          id="speed-dial"
          style={{
            bottom: '5rem',
            position: 'fixed',
            right: '20px',
          }}
          ariaLabel="Add Agent(s)"
          onClick={event => (Boolean(anchor) ? close() : open(event.currentTarget))}
          open={Boolean(anchor)}
          direction="up"
          icon={<SpeedDialIcon />}
        >
          {(props.scopes.includes(Scope.BulkAddIndependentAgents) ||
            props.scopes.includes(Scope.BulkAddExclusiveAgents)) && (
            <SpeedDialAction
              key="upload-excel-file"
              icon={<i className="fa fa-upload" />}
              tooltipOpen
              tooltipTitle="Upload Excel File"
              onClick={() => {
                props.showModal(
                  ModalState.UsersRegistration({
                    onClose: props.searchCustomerUsers,
                  })
                );
                close();
              }}
            />
          )}
          {props.scopes.includes(Scope.AddIndependentAgentPreregistration) && (
            <SpeedDialAction
              icon={<i className="fa fa-user" />}
              tooltipOpen
              tooltipTitle="Add Agent"
              onClick={() => {
                props.history.push(UserRouteConstants.INDEPENDENT_AGENT_PREREGISTRATION);
                close();
              }}
            />
          )}
          {props.scopes.includes(Scope.AddIndependentAgentPreregistration) && (
            <SpeedDialAction
              icon={<i className="fa fa-user" />}
              tooltipOpen
              tooltipTitle="Add Agent Support"
              onClick={() => {
                props.history.push(UserRouteConstants.INDEPENDENT_AGENT_SUPPORT);
              }}
            />
          )}
        </SpeedDial>
      </>
    )}
  </MenuStateProvider>
));

export default withRouter(AddCustomerSupportMenu);
